module.exports = __webpack_public_path__ + "images/1-if9987aca92e407627706cb9c5a6a1d25.svg";